import * as React from 'react';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import { trackOpenDrawer } from '../../tracking';

import { Content } from './Content';
import { Header } from './Header';
import { DrawerOrModalWrapper } from './styled';

interface DrawerOrModalProps {
  footerContent?: React.ReactNode;
}

export const DrawerOrModal = ({ footerContent }: DrawerOrModalProps) => {
  const { getTimeFromInit } = useTrackingContext();

  React.useEffect(() => {
    trackOpenDrawer({ timing: getTimeFromInit() });
  }, [getTimeFromInit]);

  return (
    <>
      <DrawerOrModalWrapper>
        <Header />
        <Content />
      </DrawerOrModalWrapper>

      {footerContent}
    </>
  );
};
